import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // ✅ Ավելացված է
import { API_BASE } from './apiConfig'; 

const OrderActionModal = ({ isOpen, data, onAction, socket }) => {
    const { t } = useTranslation(); // ✅ i18n հուկ
    const [rating, setRating] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [isMinimized, setIsMinimized] = useState(false);
    const [storedData, setStoredData] = useState(null);
    const [copyStatus, setCopyStatus] = useState('');

    useEffect(() => {
        if (isOpen && data) {
            localStorage.setItem('pending_order_action', JSON.stringify(data));
            setIsMinimized(false);
        }
    }, [isOpen, data]);

    useEffect(() => {
        const saved = localStorage.getItem('pending_order_action');
        if (saved) {
            setStoredData(JSON.parse(saved));
        }
    }, [isOpen]);

    const activeData = data || storedData;

    if (!activeData) return null;

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        setCopyStatus(t('copy_status_success', { defaultValue: 'Պատճենված է' }));
        setTimeout(() => setCopyStatus(''), 2000);
    };

const handleActionSubmit = async (actionType, payload) => {
    // 1. Վերցնում ենք ID-ները՝ ավելացնելով oldOrderId տարբերակը
    const newId = activeData.newOrderId || activeData.id;
    const oldId = activeData.oldOrderId || activeData.parentId || activeData.parent_id;

    console.log("🔍 Modal Data Check:", { 
        activeData, 
        extractedNewId: newId, 
        extractedOldId: oldId 
    });

    if (actionType === 'price_approve') {
        // Եթե այստեղ oldId-ն դեռ undefined է, ուրեմն activeData-ի մեջ տվյալ չկա
        if (!newId || !oldId) {
            console.error("❌ ID-ները բացակայում են!", { newId, oldId });
            alert(`Տվյալների սխալ: ID-ները չեն գտնվել (OldID: ${oldId})`);
            return;
        }

        try {
            const token = localStorage.getItem('token'); 
            
            console.log("🚀 Հարցում է գնում Backend-ին...", { newOrderId: newId, parentId: oldId });

         const response = await fetch(`${API_BASE}/api/orders/approve-revision`, {
    method: 'POST',
    headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
    },
    body: JSON.stringify({ 
        orderId: newId,      // 👈 Ավելացրու սա (Backend-ը սրան է սպասում)
        newOrderId: newId, 
        parentId: oldId 
    })
});

            const result = await response.json();
            
            if (result.success) {
                console.log("✅ Հաստատվեց:", result.message);
                // Այստեղ կարող ես հավելյալ UI թարմացում անել
            } else {
                console.error("❌ Backend error:", result.error || result.message);
                alert("Սխալ: " + (result.error || result.message));
                return; // Եթե սխալ է, կանգնեցնում ենք
            }
        } catch (err) {
            console.error("🔥 Network error:", err);
            return;
        }
    }

    // 2. Socket-ի և այլ գործողությունների կատարում
    console.log("📡 Emit socket event:", actionType);
    onAction(actionType, payload);

    if (socket) {
        const eventName = actionType === 'pay_finish' ? 'payment_confirmed' : 'price_response';
        socket.emit(eventName, { ...payload, newOrderId: newId, parentId: oldId });
    }

    localStorage.removeItem('pending_order_action');
    setStoredData(null);
};
    const shouldShowFloating = isMinimized || (!isOpen && storedData);

    const displayPrice = activeData.totalPrice || activeData.total_price || activeData.newPrice || 0;
    const displayService = activeData.service || activeData.service_name || t('order_finish_title');
    const displayOrderId = activeData.orderId || activeData.id;

    if (shouldShowFloating) {
        return (
            <div style={floatingButtonStyle} onClick={() => setIsMinimized(false)}>
                <span style={{ marginRight: '10px' }}>🔔</span>
                {activeData.type === 'ORDER_FINISHED_APPROVE' 
                    ? `${t('floating_pay_waiting')} (${displayPrice} ֏)` 
                    : t('floating_price_change')}
            </div>
        );
    }

    if (!isOpen && !storedData) return null;

    const isFinish = activeData.type === 'ORDER_FINISHED_APPROVE';

    return (
        <div className="order-modal-overlay" style={overlayStyle}>
            <div className="order-modal-content" style={modalStyle}>
                <button onClick={() => setIsMinimized(true)} style={closeBtnStyle}>✕</button>

                {isFinish ? (
                    <>
                        <h3 style={{ color: '#28a745', fontSize: '1.4rem', marginBottom: '10px' }}>
                           🏁 {t('order_finish_payment')}
                        </h3>
                        <p style={{ color: '#666', fontSize: '14px' }}>{t('order_finish_subtitle')}</p>
                        
                        <div style={priceCardStyle}>
                            <p style={{ margin: '0 0 5px 0' }}><b>{displayService}</b></p>
                            <p style={priceAmountStyle}>{displayPrice} ֏</p>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <p style={labelStyle}>{t('payment_method_label')}</p>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <button 
                                        onClick={() => setPaymentMethod('cash')}
                                        style={{ ...methodBtnStyle, borderColor: paymentMethod === 'cash' ? '#28a745' : '#ddd', background: paymentMethod === 'cash' ? '#f0fff4' : 'white' }}
                                    >💵 {t('payment_method_cash')}</button>
                                    <button 
                                        onClick={() => setPaymentMethod('online')}
                                        style={{ ...methodBtnStyle, borderColor: paymentMethod === 'online' ? '#4318FF' : '#ddd', background: paymentMethod === 'online' ? '#f4f7fe' : 'white' }}
                                    >💳 {t('payment_method_online')}</button>
                                </div>
                                {activeData.can_pay_later === 1 && (
                                    <button 
                                        onClick={() => setPaymentMethod('pay_later')}
                                        style={{ ...methodBtnStyle, borderColor: paymentMethod === 'pay_later' ? '#ff9800' : '#ddd', background: paymentMethod === 'pay_later' ? '#fff8e1' : '#fdfdfd', color: '#e65100' }}
                                    >⏳ {t('payment_method_later')}</button>
                                )}
                            </div>
                        </div>

                        {paymentMethod === 'online' && (
                            <div style={onlineInfoBoxStyle}>
                                <p style={{ fontSize: '12px', fontWeight: 'bold', color: '#4318FF', textAlign: 'left', marginBottom: '8px' }}>
                                    {t('online_payment_instruction')}
                                </p>
                                <div style={accountRowStyle}>
                                    <span>🆔 Idram: <b>123456789</b></span>
                                    <button onClick={() => handleCopy('123456789')} style={copyBtnStyle}>{t('btn_copy')}</button>
                                </div>
                                <div style={accountRowStyle}>
                                    <span>🏦 Bank: <b>22000...</b></span>
                                    <button onClick={() => handleCopy('220000000000')} style={copyBtnStyle}>{t('btn_copy')}</button>
                                </div>
                                {copyStatus && <span style={{fontSize: '10px', color: '#28a745'}}>{copyStatus}</span>}
                                <div style={warningBoxStyle}>
                                    {t('payment_comment_warning')} <b>#{displayOrderId}</b>
                                </div>
                            </div>
                        )}

                        <div style={{ marginBottom: '20px', marginTop: '15px' }}>
                            <p style={labelStyle}>{t('rate_master_label')}</p>
                            {[1, 2, 3, 4, 5].map((star) => (
                                <span key={star} onClick={() => setRating(star)} style={{ fontSize: '30px', cursor: 'pointer', color: star <= rating ? '#ffc107' : '#e4e5e9', margin: '0 4px' }}>★</span>
                            ))}
                        </div>

                        <button 
                            disabled={rating === 0 || !paymentMethod}
                            style={{ ...submitBtnStyle, background: (rating > 0 && paymentMethod) ? '#28a745' : '#ccc' }}
                            onClick={() => handleActionSubmit('pay_finish', { ...activeData, rating, paymentMethod })}
                        >
                            {paymentMethod === 'online' ? t('btn_confirm_transfer') : t('btn_confirm_payment')}
                        </button>
                    </>
                ) : (
                    <div style={{ textAlign: 'center' }}>
                        <h3 style={{ color: '#4318FF' }}>⚠️ {t('price_change_title')}</h3>
                        <p style={{ color: '#666', fontSize: '14px' }}>{t('price_change_subtitle')}</p>
                        
                        <div style={{ ...priceCardStyle, background: '#f4f7fe', borderColor: '#4318FF' }}>
                            <p style={{ textDecoration: 'line-through', color: '#888', margin: 0, fontSize: '0.9rem' }}>{activeData.oldPrice} ֏</p>
                            <p style={{ ...priceAmountStyle, color: '#4318FF' }}>{activeData.newPrice} ֏</p>
                        </div>

                        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                            <button 
                                style={{ ...methodBtnStyle, background: '#28a745', color: 'white', border: 'none', flex: 2 }}
                                onClick={() => handleActionSubmit('price_approve', { ...activeData, status: 'approved' })}
                            >{t('btn_agree')}</button>
                            <button 
                                style={{ ...methodBtnStyle, background: '#fff', color: '#dc3545', borderColor: '#dc3545', flex: 1 }}
                                onClick={() => handleActionSubmit('price_reject', { ...activeData, status: 'rejected' })}
                            >{t('btn_reject')}</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const overlayStyle = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, backdropFilter: 'blur(5px)' };
const modalStyle = { background: 'white', padding: '25px', borderRadius: '25px', maxWidth: '380px', width: '90%', textAlign: 'center', position: 'relative' };
const closeBtnStyle = { position: 'absolute', top: '15px', right: '15px', border: 'none', background: '#eee', borderRadius: '50%', width: '25px', height: '25px', cursor: 'pointer' };
const priceCardStyle = { margin: '15px 0', padding: '12px', background: '#f0fff4', borderRadius: '12px', border: '1px dashed #28a745' };
const priceAmountStyle = { fontSize: '1.4rem', fontWeight: '900', color: '#2ecc71', margin: 0 };
const labelStyle = { marginBottom: '8px', fontSize: '0.8rem', color: '#888', fontWeight: '600', textTransform: 'uppercase' };
const methodBtnStyle = { flex: 1, padding: '12px', borderRadius: '12px', border: '2px solid', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem' };
const submitBtnStyle = { color: 'white', border: 'none', width: '100%', padding: '14px', borderRadius: '12px', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer', marginTop: '10px' };

const onlineInfoBoxStyle = { background: '#f8faff', padding: '12px', borderRadius: '15px', border: '1px solid #d1d9ff', marginTop: '10px' };
const accountRowStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'white', padding: '6px 10px', borderRadius: '8px', marginBottom: '5px', fontSize: '12px', border: '1px solid #edf2f7' };
const copyBtnStyle = { background: '#4318FF', color: 'white', border: 'none', padding: '3px 7px', borderRadius: '5px', fontSize: '10px', cursor: 'pointer' };
const warningBoxStyle = { background: '#fff5f5', color: '#e53e3e', padding: '6px', borderRadius: '6px', fontSize: '11px', marginTop: '5px' };

const floatingButtonStyle = {
    position: 'fixed', bottom: '25px', left: '50%', transform: 'translateX(-50%)',
    background: '#4318FF', color: 'white', padding: '12px 24px', borderRadius: '50px',
    boxShadow: '0 8px 20px rgba(67, 24, 255, 0.3)', zIndex: 10000, cursor: 'pointer',
    fontWeight: 'bold', display: 'flex', alignItems: 'center'
};

export default OrderActionModal;